export const navigationLinks = [
  {
    text: 'home',
    href: '/#',
  },
  {
    text: 'about',
    href: '/#section-about',
  },
  {
    text: 'experience',
    href: '/#section-experience',
  },
  {
    text: 'work',
    href: '/#section-work',
  },
  {
    text: 'contact',
    href: '/#section-contact',
  },
];

export const emailAddress = 'aminpainter786@gmail.com';
